module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/nft-1-918222bb37092df3fe0985744bdba4e6.png";